<template>
    <div :class="{ 'lomaltap1-img': customImgLomalta }" style="position: relative;">
        <div v-if="(img && !imageLoaded) || selectingLoading" class="map-loading-overlay">
            <p>Cargando...</p>
        </div>
        <div :class="widthSvg">
            <!-- <div class="btn__model-container">
                <button :id="location.name" class="btn__model" :class="{ 'btn__model-disabled': location.unavailable == 1,'btn__model-active':desarrollo=='torreaireaplus' }"
                    :disabled="location.unavailable == 1" @click="selectLocation(location)"
                    v-for="(location, index) in model" :key="index">
                    {{ location.name }}
                </button>
            </div> -->
             <svg v-if="img" class="torrespiso_individual" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="img.viewBox" xml:space="preserve">
              <image
                  style="overflow: visible"
                  :width="img.width"
                  :height="img.height"
                  :xlink:href="`${img.url}`"
                  :transform="img.transform"
                  @load="imageLoaded = true"
              >

              </image><!-- -->
              <polygon
                  class="polygon"
                  v-on:mouseover="inLocation(location, index)"
                  v-on:mouseout="outLocation(location, index)"
                  @click="selectLocation(location)"
                  v-for="(location, index) in filterMapAvaialbles"
                  :key="location.name+'A'"
                  :points="location.coords"
                  :shape="location.shape"
                  :style="customPolygon(index)"
                  
                  :name="`${location.name}`"
                  :class="{'active':activeLocationPoly==`${location.name}`&& colored=='on'}"
                  :id="`${location.name}_Torre`"
                />
                <polygon
                    class="polygon"
                    v-show="showDisabledLocations"
                    v-for="locationD in filterMapAvaialbles"
                    :key="locationD.name+'B'"
                    :points="locationD.coords"
                    :shape="locationD.shape"
                    
                    :name="`${locationD.name}`"
                /><!-- :style="customPolygonDisabled(index)"
                    :stroke="locationD.color" -->
                
                <indicators v-for="indicator in setIndicators" :indicator="indicator" :key="'A' + indicator.text"
                            :filterMapAvaialbles="filterMapAvaialbles"/>
                <text v-show="showDisabledLocations"
                    v-for="(locationD, index) in showDisabledLocations"
                    :key="index"  :transform="locationD.transform" class="st1 st2 st-canadas">
                    {{locationD.text}}
                </text>
                
            </svg>
            <div v-if="desarrollo==='canadas_deptos-piso'">
                <tippy theme="honeybee" size="large" distance="3" ignoreAttributes="true" arrow="true" interactive="true" animation="fade" allowHTML="true" v-for="location in filterMapAvaialbles" :key="location.id" :to="`${location.name}`">
                    <Tooltip :location="location" :type="type" />
                </tippy>
            </div>
            <!-- <div v-if="img.levelId==232 || img.levelId==149 " style="text-align:center">
                <img style="max-width:350px;width:30%" src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/privadas/simbologia/privada17.png" alt="simbologia">
            </div>
            <div v-if="img.levelId==178 || img.levelId==233 " style="text-align:center">
                <img style="max-width:350px;width:37%" src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/privadas/simbologia/casas_chicas.png" alt="simbologia">
            </div> -->
        </div>
        <!-- <map-view-detail v-if="stateMapDetail" /> -->
    </div>
</template>

<script>
import Tooltip from "../../core/Tooltip.vue"
//import Indicators from "../Indicators";
import { mapActions, mapGetters } from "vuex";
/* import MapViewDetail from "../core/MapViewDetail"; */

export default {
    name: "MapHighlightPiso",
    props: ["existFilter", "img", "desarrollo", "url", "nivel", "indicators", "type", "lomalta", 'named', "locationsDisabled"],
    components: {
        Tooltip,
        // Indicators,
        //MapViewDetail,
    },
    data() {
        return {
            opacity: 0.4,
            stroke: 3,
            target: null,
            name: "",
            offIndicator: false,
            onIndicator: true,
            activeLocation:"",
            imageLoaded: false,
            selectingLoading: false
        };
    },
    computed: {
        ...mapGetters({
            filterModelos: "getStatusFilterModelos",
            stateMapDetail: "getStatusMapDetail",
            levelDept: "getStatusLevel",
            modelos: "getSelectedLevel",
            selectDtp:"getStatusA",
            colored:"getStatusAllElements"
        }),
        activeLocationPoly(){
            return this.activeLocation
        },
        customImgLomalta() {
            if (this.$route.params.id == 150 && this.desarrollo == 'lomalta-priv') {
                return true
            } else {
                return false
            }
        },
        filterMapAvaialbles() {
            if (this.lomalta) {
                return this.existFilter.filter((location) => location.id != 112)
            } else if (this.nivel === 'towerStage' || this.nivel === 'towerStageLevel') {
                if (this.desarrollo == 'canadas_terrenos' || this.desarrollo == 'canadas_casas') {
                    return this.existFilter.filter((location) => location.available >= 0)
                } else {
                    return this.existFilter.filter((location) => location.available > 0)
                }
            } else if (this.type === 'casas') {
                return this.filterModelos
            } else {
              if (this.desarrollo == 'torrespaseodelparquepiso' || this.desarrollo == 'canadas_deptos-piso' || this.desarrollo === 'torrevistahermosapiso') {
                   return this.modelos 
                }else{
                    let filtro = this.modelos.filter((location) => location.name == this.levelDept.name)
                    return filtro
                }
                
            }
        },
        setIndicators() {
            return this.indicators
        },
        widthSvg() {
            if (this.desarrollo === 'canadas_deptos-piso' || this.desarrollo === 'torrespaseodelparquepiso' || this.desarrollo === 'torrevistahermosapiso') {
                return 'box__svg-deptos'
            } else if (this.desarrollo === 'paseodelparqueSubMenu') {
                return 'box__svg-pdp'
            } else if (this.desarrollo === 'bosques_casas') {
                return 'box__svg-bosques'
            }
            return 'box__svg'
        },
        showDisabledLocations() {
            if (this.locationsDisabled) {
                return this.locationsDisabled
            } else {
                return false
            }
        },
        model(){
            if(this.desarrollo=='torreaireaplus'){
                if(this.levelDept.lado=="IZQ"){
                    let elementSide = this.modelos.filter((item)=>item.name.includes('A'))
                    return elementSide
                }else if(this.levelDept.lado=="DER"){
                    let elementSide = this.modelos.filter((item)=>item.name.includes('B'))
                    return elementSide
                }else{
                    return this.modelos
                }
            }else{
                return this.modelos
            }
        }
    },
    methods: {
        ...mapActions(["selectedLocation", "getSelectedDpts", "getAvailableImageLocation","getAllElements"]),
        selectLocation(location) {
            if (this.nivel === 'availability') {
                this.selectAvailability(location)
            } else if (this.nivel === 'towerStage') {
                this.selectTowerStage(location)
            } else if (this.nivel === 'towerStageLevel') {
                this.selectTowerStageLevel(location)
            }
        },
        async selectAvailability(location) {
            if (location.statusText === "Disponible") {
                this.selectingLoading = true;
                try {
                    await this.getSelectedDpts(location);
                    await this.getAvailableImageLocation(location);
                    this.desactiveBtn();
                    this.activeBtn(location.name);
                    await this.getAllElements("on");
                    this.$emit('activeDetailPiso');
                    this.activeLocation='';
                    this.desactivePiso();
                    this.activeLocation=`${location.name}`
                    this.activePiso(location.name)
                } finally {
                    this.selectingLoading = false;
                }

                // this.$router.push(`${this.url}/${location.name}`)
            } else {
                if (location.statusText === "Reservado" || location.statusText === "Vendido") {
                    event.preventDefault();
                }
            }
        },
        selectTowerStageLevel(location) {
            if (location.available > 0) {
                this.selectedLocation(location)
                let nameNoSpace = location.name.replace(/ /g, "");
                this.$router.push({ path: `${this.url}/cve_nivel_te=${location.id}/nombre_nivel_te=${nameNoSpace}` })
            } else {
                event.preventDefault();
            }
        },
        selectTowerStage(location) {
            if (location.available > 0) {
                this.selectedLocation(location)
                let nameNoSpace = location.name.replace(/ /g, "");
                if (this.desarrollo == 'paseodelparque') {
                    this.$router.push({ path: `/paseodelparque/nombre_torre_etapa=ETAPA5/cve_torre_etapa=14/cve_nivel_te=196/nombre_nivel_te=BIS` })
                } else {
                    this.$router.push({
                        path: `/${this.url}/nombre_torre_etapa=${nameNoSpace}/cve_torre_etapa=${location.id}`,
                        params: { torre: nameNoSpace, id: location.id }
                    })
                }
            } else {
                event.preventDefault();
            }
        },
        inLocation(location, index) {
            this.name = location.name
            event.target.style.opacity = 0.3;
            event.target.style.fill = "#" + location.color;
            if (this.nivel === 'towerStageLevel' || this.nivel === 'towerStage') {
                if (location.name === this.setIndicators[index].text) {
                    this.setIndicators[index].status = this.offIndicator
                }
            }
        },
        outLocation(location, index) {
            this.name = "";
            event.target.style.opacity = 0.4;
            if(this.desarrollo == 'torrevistahermosapiso' && location.available==0){
              event.target.style.fill = `#B00000`;
            } else {
              event.target.style.fill = `#${this.filterMapAvaialbles[index].color}`;
            }
            if (this.nivel === 'towerStageLevel' || this.nivel === 'towerStage') {
                if (location.name === this.setIndicators[index].text) {
                    this.setIndicators[index].status = this.onIndicator
                }
            }
        },
        customPolygon(index) {
            let location = this.filterMapAvaialbles[index];
            if (this.desarrollo == 'torrevistahermosapiso' && location.available== 0) {
              return `stroke-width:3; stroke:#B00000; opacity: ${this.opacity}; fill: #B00000`;
            } else {
              return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${location.color}`;
            }
          },

          customPolygonDisabled() {
            return `stroke-width:3; stroke:#B00000; opacity: ${this.opacity}; fill: #B00000`;
        },
        //add
        desactiveBtn() {
            let btns = document.querySelectorAll('.btn__model-container button');
            /*  let cont = 0; */

            for (let index = 0; index < btns.length; index++) {
                const element = btns[index];

                if (element.getAttribute("disabled") != "disabled") {
                    element.classList.remove('btn__model-active')
                }

            }
        },
        desactivePiso(){
            let element = document.querySelectorAll('.torrespiso_individual .polygon')
            element.forEach((item)=>{
                item.classList.remove('active')
            });
        },
        activeBtn(id) {
            let button = document.getElementById(id)
            if(button){
                button.classList.add('btn__model-active');
            }
            
        },
        activePiso(name){
            let element = document.getElementById(`${name}_Torre`);
            element.classList.add('active')
        },
        beforeDestroy() {
            this.indicators = [];
        }
    },
};
</script>
<style>
.map-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    text-align: center;
    padding: 50px 0;
    background: #fff;
}
.torrea .box__svg-deptos {
    width: 100%;
}
.btn__model {
    padding: 5px 20px;
    background: transparent;
    border: 2px solid #152541;
    border-radius: 5px;
    color: #152541
}

.btn__model-container {
    margin-bottom: 10px;
    width: 100%;
}

.btn__model.btn__model-disabled {
    border: 2px solid #b3261e;
    border-radius: 5px;
    color: #b3261e;
    cursor:auto ;
}

.btn__model-container button {
    cursor: pointer;
    margin: 0 5px;
    margin-bottom: 10px;
}

.btn__model:first-child {
    margin: 0;
}

.btn__model:nth-child(2) {
    margin-left: 10px;
}

.btn__model-active {
    background: #152541;
    color: white;
}</style>



